export enum TableShape {
	rectangle = 'rectangle',
	round = 'round',
}

export enum TableType {
	table = 'Table',
	tableCombination = 'TableCombination',
}
